import {
	FormControl,
	Input,
	FormErrorMessage,
	Flex,
	FormLabel,
} from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import { User } from "../../types/user.types";
import PrimaryButton from "../PrimaryButton";
import { useMutation } from "react-query";
import { updateUser } from "../../queries/user.queries";
import { MutateErrors, mutateOnError } from "../../lib/generic";
import { fPhoneNumber } from "../../lib/format";

type UserFormProps = {
	user: User;
	onSuccess?: () => void;
};

function UserForm({ user, onSuccess }: UserFormProps) {
	const methods = useForm();
	const { mutate: mutateUpdateUser } = useMutation(updateUser, {
		onSuccess: () => {
			if (onSuccess) {
				onSuccess();
			}
		},
		onError: (err: MutateErrors) => {
			mutateOnError(err);
			err.response.data.errors.forEach((error) => {
				methods.setError(error.field, {
					message: error.message,
				});
			});
		},
	});

	const onSubmit = async () => {
		mutateUpdateUser({
			id: user.id,
			email: methods.getValues("email"),
			firstName: methods.getValues("firstName"),
			lastName: methods.getValues("lastName"),
			phoneNumber: methods.getValues("phoneNumber"),
		});
	};

	return (
		<FormProvider {...methods}>
			<form style={{ marginTop: "32px", marginBottom: "32px" }}>
				<Flex direction="column" gap="24px">
					<Flex gap="24px">
						<FormControl isInvalid={!!methods.formState.errors.firstName}>
							<FormLabel>Prénom</FormLabel>
							<Input
								id="firstName"
								placeholder="Prénom"
								defaultValue={user.firstName}
								{...methods.register("firstName", {
									required: "Ce champ est obligatoire",
								})}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.firstName?.message}</>
							</FormErrorMessage>
						</FormControl>
						<FormControl isInvalid={!!methods.formState.errors.lastName}>
							<FormLabel>Nom</FormLabel>
							<Input
								id="lastName"
								placeholder="Nom"
								defaultValue={user.lastName}
								{...methods.register("lastName", {
									required: "Ce champ est obligatoire",
								})}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.lastName?.message}</>
							</FormErrorMessage>
						</FormControl>
					</Flex>
					<FormControl isInvalid={!!methods.formState.errors.email}>
						<FormLabel>Email</FormLabel>

						<Input
							id="email"
							placeholder="Email"
							defaultValue={user.email}
							{...methods.register("email", {
								required: "Ce champ est obligatoire",
							})}
						></Input>
						<FormErrorMessage>
							<>{methods.formState.errors?.email?.message}</>
						</FormErrorMessage>
					</FormControl>
					<FormControl isInvalid={!!methods.formState.errors.phoneNumber}>
						<FormLabel>Téléphone</FormLabel>
						<Input
							id="phoneNumber"
							placeholder="Téléphone"
							defaultValue={fPhoneNumber(user.phoneNumber ?? "")}
							{...methods.register("phoneNumber")}
						></Input>
						<FormErrorMessage>
							<>{methods.formState.errors?.phoneNumber?.message}</>
						</FormErrorMessage>
					</FormControl>

					<PrimaryButton type="button" onClick={onSubmit}>
						Sauvegarder
					</PrimaryButton>
				</Flex>
			</form>
		</FormProvider>
	);
}

export default UserForm;
